/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { memo } from 'react'
import {
  Input,
  Text,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Box,
} from '@chakra-ui/react'
import { Field, FieldProps } from 'formik'
import { BaseFieldProps } from '.'

interface FormikInputProps extends BaseFieldProps {
  placeholder?: string
  iconLeft?: React.ReactChild
  iconRight?: React.ReactChild
  style?: any
  wrapperStyle?: any
}

const FormikInput: React.FC<FormikInputProps> = ({
  label,
  name,
  placeholder = '',
  iconLeft,
  iconRight,
  required = false,
  wrapperStyle,
  ...rest
}) => {
  return (
    <Box style={wrapperStyle}>
      {label && (
        <Text fontWeight={500} marginBottom="1">
          {label} {required && '*'}
        </Text>
      )}
      <Box>
        <Field name={name} {...rest}>
          {({ field, meta }: FieldProps) => {
            return (
              <Box>
                <InputGroup>
                  {iconLeft && <InputLeftElement>{iconLeft}</InputLeftElement>}
                  <Input
                    type="text"
                    placeholder={placeholder}
                    {...rest}
                    {...field}
                    value={field.value || ''}
                  />
                  {iconRight && (
                    <InputRightElement>{iconRight}</InputRightElement>
                  )}
                </InputGroup>
                {meta.touched && meta.error && (
                  <Text color="red.500">{meta.error}</Text>
                )}
              </Box>
            )
          }}
        </Field>
      </Box>
    </Box>
  )
}

export default memo(FormikInput)
